<template>
<DBox class="cmp-settings-billing-support_issue" :id="'settings-billing-support_issue'" :addButton="false">
                
                    <NTable
                      :id="'settings-billing-support_issue'"
                      class="h2"
                      :items="support"
                      :headers="supportHeaders"
                      :config="createNTableConfig({
                          headerStyle: 2,
                          rowHeight: 30,
                          fullHeight: true,
                          showHeader: true
                        })"
                    >
                      <template v-slot:item="{ item, tdcon }">
                        <tr>
                          <td v-bind="tdcon('support_issue')">
                            <span>{{item.subject}} {{$t('hello')}}</span>                          
                          </td>
                          <td v-bind="tdcon('minutes')">
                            <span>{{item.duration_minutes}}</span>                          
                          </td>
                          <td v-bind="tdcon('amount')">
                            <span>{{item.cost}}</span>                          
                          </td>
                          <td v-bind="tdcon('invoice_date')">
                            <span>{{item.support_date}}</span>                          
                          </td>
                        </tr>
                      </template>
                    </NTable>
                
                </DBox>


</template>


<script>
import DBox from "@dtplugins/dbox/dbox";
import NTable from "@/plugins/datatable/datatable";
import { createNTableConfig, createTableHeader } from "../../../../plugins/datatable";
import { HttpClient } from "../../../../services/http/http-client";
export default {
  components: {
    DBox,



    NTable,
  },
  props: {
    billingSettingsData: {
      type: Object
    }
  },
  mounted: function () {
  },
  data: function () {
    return {

    }
    //MARK: Data Function
  },

  computed: {

    supportHeaders: function () {
      return [
        createTableHeader("support_issue"),
        createTableHeader("minutes"),
        createTableHeader("amount",{ta:'right'}),
        createTableHeader("invoice_date",{f:0.4,ta:'center'}),
      ];
    },
    support: function () {
      return this.billingSettingsData?.support || [];
    },
   
  },

  methods: {
    createNTableConfig: createNTableConfig,
    //MARK: Methods
  },
};
</script>

<style lang="scss">
.cmp-settings-billing-billing_settings_invoice,
.cmp-settings-billing-support_issue {
  height: 100%;

  .invoice {
    a {
      color: unset;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }
  }
}
</style>